import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.dokument-veranstaltungs-typen-hinzufuegen';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenDokumentVeranstaltungsTypenHinzufuegenEffects {

    DokumentVeranstaltungsTypenHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_DOKUMENT_VERANSTALTUNGS_TYPEN_HINZUFUEGEN),
        mergeMap((x: ac.PostDokumentVeranstaltungsTypenHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postDokumentVeranstaltungsTypenHinzufuegen(x.dokumentVeranstaltungsTypMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostDokumentVeranstaltungsTypenHinzufuegenErfolgreichAction(result, x.dokumentVeranstaltungsTypMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostDokumentVeranstaltungsTypenHinzufuegenFehlerAction(error, x.dokumentVeranstaltungsTypMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DokumentCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DokumentCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.DokumentCommandService);
        }
        return this.service;
    }
}
